// @ts-nocheck
import { useState, useEffect, useCallback } from 'react';

export const AppStatusBar = () => {
    const [camera, setCamera] = useState({
        x: 0.00,
        y: 0.00,
        z: 0.00
    });
    const [FPSintervalId, setFPSintervalId] = useState(0);
    const [TerrainintervalId, setTerrainintervalId] = useState(0);
    const [MouseintervalId, setMouseintervalId] = useState(0);
    const [FPS, setFPS] = useState(0.0);
    const [terrainNod, setTerrainNod] = useState(0.0);

    const cameraPOS = useCallback(() => {
        let Camera = window.main.OView.camera.pos;
        if (Camera !== null)
            setCamera(Camera)
        requestAnimationFrame(cameraPOS);
    }, []);
    const getFPS = useCallback(() => {
        if (window.main !== null) {
            setFPS(parseInt(window.main.OView.getFPS()));
            requestAnimationFrame(getFPS);
        }
    }, []);
    const getTerrainNod = useCallback(() => {
        if (window.main !== null) {
            setTerrainNod(parseInt(window.main.OView.getTerrainNodeProgress() * 100))
            requestAnimationFrame(getTerrainNod);
        }
    }, []);

    useEffect(() => {
        setMouseintervalId(requestAnimationFrame(cameraPOS))
        setFPSintervalId(requestAnimationFrame(getFPS))
        setTerrainintervalId(requestAnimationFrame(getTerrainNod))
    }, [cameraPOS, getFPS, getTerrainNod]);

    useEffect(() => {
        return () => {
            cancelAnimationFrame(MouseintervalId);
            cancelAnimationFrame(FPSintervalId);
            cancelAnimationFrame(TerrainintervalId);
        }
    }, [MouseintervalId, FPSintervalId, TerrainintervalId])

    const cameraZCover = () => {
        let z = parseFloat(camera.z);
        let unit = " 公尺";
        if (z >= 1000.0) {
            unit = " 公里";
            z = parseFloat(z / 1000.0);
        }
        return (z.toFixed(2).toString() + unit);

    }
    return (
        <div id="statusBar">
            <div id="mousePos">
                PilotGaea_v.13　
                {
                    terrainNod === 100 ?
                        <i className="pi pi-check-circle"></i>
                        :
                        <i className="pi pi-spin pi-spinner"></i>
                }
                　{(terrainNod) + "%"}　　FPS：{FPS}　　相機高度：{cameraZCover()}　　相機經度：{camera.x.toFixed(4)}　　相機緯度：{camera.y.toFixed(4)}
            </div>
        </div>
    );
}
